import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Loading from '../../style-components/Loading.jsx';
import LearningPathForm from './LearningPathForm/LearningPathForm.jsx';

import { useGetLearningPath, putLearningPath } from '../../models/learning_path';

const generateSelectionsOfLearningPath = data => {
  // Se crea un objeto vacío para almacenar las selecciones
  const selections = {};
  const units = data.units || [];
  units.forEach(unit => {
    // Primero se crea el objeto de selección para la unidad
    selections[unit.learnunit_id] = {};
    const anatomical_structures = unit.anatomical_structures || [];
    const videos = unit.videos || [];
    const images = unit.images || [];
    if (anatomical_structures.length > 0) {
      selections[unit.learnunit_id].anatomical_structures = anatomical_structures;
    }
    if (videos.length > 0) {
      selections[unit.learnunit_id].videos = videos;
    }
    if (images.length > 0) {
      selections[unit.learnunit_id].images = images;
    }
  });
  // Se devuelve el objeto de selecciones
  return selections;
};

function LearningPathEdit() {
  const navigate = useNavigate();
  const { id: courseId, learning_path_id: learningPathId } = useParams();

  const [path, loading] = useGetLearningPath(courseId, learningPathId);

  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async payload => {
    setSubmitting(true);
    const response = await putLearningPath(courseId, learningPathId, payload);
    setSubmitting(false);
    if (response.status === 200) {
      alert('Ruta de aprendizaje actualizada con éxito.');
      navigate(`/courses/${courseId}/learning-paths/${learningPathId}`);
    } else {
      const message =
        response?.response?.data?.message ||
        response?.response?.data ||
        'No se pudo actualizar la ruta de aprendizaje.';
      alert(message);
    }
  };

  if (loading) {
    return (
      <div className='flex w-full justify-center py-20'>
        <Loading />
      </div>
    );
  }

  if (!path) {
    return (
      <div className='w-full p-5'>
        <div className='rounded-xl border border-border bg-white px-6 py-16 text-center text-muted-foreground'>
          No se encontró la ruta de aprendizaje.
        </div>
      </div>
    );
  }

  const selections = generateSelectionsOfLearningPath(path);

  return (
    <LearningPathForm
      mode='edit'
      submitting={submitting}
      initialData={{ title: path.title, description: path.description, selections }}
      onSubmit={handleSubmit}
    />
  );
}

export default LearningPathEdit;
